class window.AjaxLoadNewsContent
  constructor: ->
    self  = this
    @itemsContainer = $('.js-loaded-items-container')
    @mainItemContainer = $('.js-loaded-items-main-container')
    @loadButton = $('.js-pagination')
    @loadIcon = $('.js-base-icon-loader')
    @loadMore = true
    @newsList = undefined
    @rowCount = 0
    @columnCount = 0
    @pageNumber = 1

    @init()

  init: (@startDate = null, @endDate = null, @territory = null, @rubric = null)->
    self = this
    @pageNumber = 1
    @newsList = { ITEMS: [], MAIN_NEW: null, HAS_NEXT_PAGE: true }
    @rowCount = 0
    @columnCount = 0
    url = window.location.href.split('/news/');
    sectionPart = if url[1] and url[1] != '' then url[1] else null
    @section = if sectionPart then sectionPart.replace(/\/$/, '') else null

    $(self.loadIcon).addClass('base-icon-loader--active')
    $.ajax
      url: '/news/json_news.php',
      data: {
        section: self.section
        rubric: self.rubric
        startDate: self.startDate
        endDate: self.endDate
        territory: self.territory
        page: self.pageNumber
      },
      dataType: 'json',
      success: (data, status, xhr) ->
        $(self.loadIcon).removeClass('base-icon-loader--active')
        self.clearContent()
        self.newsList = data
        self.loadPage(self.newsList, status, xhr)
        self.initLoadButton()
        new window.NewsPopup()
        self.pageNumber++

  initLoadButton: ->
    self = this
    @loadButton.click (e) ->
      e.preventDefault()
      if self.newsList.HAS_NEXT_PAGE
        setTimeout (->
          self.renderLoadedItems(0, self.newsList.ITEMS)
          new window.NewsPopup()
        ), 500
      else
        loadButton = self.loadButton
        if self.loadMore
          self.loadMore = false
          rubric = window.location.href.split('/')

          if window.NewsObject.startDate
            startDate = window.NewsObject.startDate
          else
            startDate = null

          if window.NewsObject.endDate
            endDate = window.NewsObject.endDate
          else
            endDate = null

          self.startDate = startDate
          self.endDate = endDate

          $(self.loadIcon).addClass('base-icon-loader--active')

          $.ajax
            url: '/news/json_news.php',
            data: {
              section: self.section
              startDate: self.startDate
              endDate: self.endDate
              territory: self.territory
              page: self.pageNumber
              rubric: self.rubric

            },
            dataType: 'json',
            success: (data, status, xhr) ->
              $(self.loadIcon).removeClass('base-icon-loader--active')
              setTimeout (->
                if data.ITEMS.length == 0 && !data.HAS_NEXT_PAGE
                    self.renderRestNews(self.newsList.ITEMS)
                    $('.js-pagination').remove()
                    self.newsList = new Object(ITEMS: [], HAS_NEXT_PAGE: false)
                else
                  for i in [0..data.ITEMS.length - 1]
                    self.newsList.ITEMS.push(data.ITEMS[i])
                  self.renderLoadedItems(0, self.newsList.ITEMS)
                  self.newsList.HAS_NEXT_PAGE = data.HAS_NEXT_PAGE
                  self.pageNumber++
                  new window.NewsPopup()

                self.loadMore = true
                return
              ), 500

# метод отрисовки элементов при отрисовке
  loadPage: (data, textStatus, xhr) ->
    self = this

    mainItem = data.MAIN_NEW
    items = data.ITEMS
    index = 0

    # добавляем главную новость
    if mainItem
      @mainItemContainer.append(@getMainBlock(mainItem) || '')

      # добавляем новости справа от главной новости
      aside_items = ''
      for i in [index..2]
        aside_items += @getAsideBlock(items[i]) || ''
        index++
      @mainItemContainer.append('<div class="grid-news-list"><div class="grid-news-list-wrapper">'+aside_items+'</div></div>')

    if items.length > 0
      @renderLoadedItems(index, items, data.CORONA)
      if data.HAS_NEXT_PAGE || items.length > index || @newsList.ITEMS.length > 0
        @itemsContainer.after(@getPaginationBlock())
        @loadButton = $('.js-pagination')
      else if items.length == 0 && mainItem == undefined
        @itemsContainer.append('<div>Нет новостей удовлетворяющих условиям поиска</div>')
        $('.js-pagination').remove()


  renderLoadedItems: (start_index, data, coronaBlock = false) ->
    self = this
    items = data
    count_items = Object.keys(items).length
    imageless = false
    previous_element = undefined
    index = start_index

    for i in [index..count_items-1]
      # Показать спец.блок про корона вирус, приходит он из JSON со всеми новостями
      if(i == 2 && coronaBlock)
        @itemsContainer.append(coronaBlock)
        self.columnCount++

        if self.columnCount == 3
          self.rowCount++
          self.columnCount = 0

      # проверяем на количество выведенных строк, останавливаем массив, если количество строк превысит 2
      if self.rowCount < 2
        if items[i].PROPERTY_GALLERY_IMAGES
          @itemsContainer.append(@getBlockWithGallery(items[i]) || '')
          self.columnCount++
          index++

        else if items[i].PROPERTY_VIDEO_TAG_VALUE
          @itemsContainer.append(@getBlockWithVideo(items[i]) || '')
          self.columnCount++
          index++

        else if items[i].PREVIEW_PICTURE
          @itemsContainer.append(@getBlockWithPicture(items[i]) || '')
          self.columnCount++
          index++
        else
          @itemsContainer.append('<div class="grid__column grid__column--2news">' + (@getBlockWithoutPicture(items[i]) || "") + '</div>')
          imageless = false
          self.columnCount++
          index++


        # провереяем количество столбцов для подсчета строк
        if self.columnCount == 3
          self.rowCount++
          self.columnCount = 0
      else
        self.rowCount = 0
        break
    # оставшиеся новости оставляем на потом для подгрузки
    @rebuildNewsList(index, items)





  renderRestNews: (data) ->
    self = this
    items = data
    count_items = Object.keys(items).length
    imageless = false
    previous_element = undefined
    index = 0

    for i in [index..count_items-1]
      if items[i].PREVIEW_PICTURE
        @itemsContainer.append(@getBlockWithPicture(items[i]) || '')
        self.columnCount++
        index++
      else
        @itemsContainer.append('<div class="grid__column">' + (@getBlockWithoutPicture(previous_element) || "") + '</div>')
        imageless = false
        self.columnCount++
        index++

      # провереяем количество столбцов для подсчета строк
      if self.columnCount == 3
        self.rowCount++
        self.columnCount = 0

    @newsList = new Object(ITEMS: [], HAS_NEXT_PAGE: false)


  rebuildNewsList: (start_index, data) ->
    self = this

    items = data
    count_items = Object.keys(items).length

    @newsList = new Object(ITEMS:[])

    if start_index < count_items
      for i in [start_index..count_items - 1]
        @newsList.ITEMS.push(items[i])

  # метод генерации блока главной новости
  getMainBlock: (element) ->
    if element
      background = "background: url('"+element.DISPLAY_PREVIEW_PICTURE+"') no-repeat center; background-size: cover;"
      playIconBlock = '
        <div class="base-icon-block-content preview-big__image-icon">\n' +
        '            <div class="base-icon-block">\n' +
        '              <svg width="30" height="38" viewBox="0 0 30 38" version="1.1"\\n\' +\n' +
        '        \'     xmlns="http://www.w3.org/2000/svg"\\n\' +\n' +
        '        \'     xmlns:xlink="http://www.w3.org/1999/xlink">\\n\' +\n' +
        '        \'\\n\' +\n' +
        '        \'    <g transform="translate(-5398 -3510)">\\n\' +\n' +
        '        \'        <g>\\n\' +\n' +
        '        \'            <use xlink:href="#play_icon_svg"\\n\' +\n' +
        '        \'                 transform="matrix(6.12323e-17 1 -1 6.12323e-17 5428 3510)"/>\\n\' +\n' +
        '        \'        </g>\\n\' +\n' +
        '        \'    </g>\\n\' +\n' +
        '        \'    <defs>\\n\' +\n' +
        '        \'        <path id="play_icon_svg" fill-rule="evenodd" d="M 19 0L 38 30L 0 30L 19 0Z"/>\\n\' +\n' +
        '        \'    </defs>\\n\' +\n' +
        '        \'</svg>\n' +
        '                    </div>\n' +
        '                  </div>'
      showedPlayBlock = if typeof(element.PROPERTY_VIDEO_TAG_VALUE) == "string" then playIconBlock else ""
      htmlBlock =
        '<a href="'+element.DETAIL_PAGE_URL+'" class="preview__big preview__big-wrapper popup-block-link">
          <div class="preview-big__image-block-news">
            <div class="preview-big__image-news" style="'+background+'"></div>
            <div class="preview__image-mask-news"></div>'+showedPlayBlock+'
          </div>
          <div preview-big__info-block">
            <h2 class="preview-big__title-news">'+element.NAME+'</h2>
            <div class="preview-big__date-news">'+element.ACTIVE_FROM+'</div>
          </div>
        </a>'
      return htmlBlock






  # метод генерации блоков справа от главной новости
  getAsideBlock: (element) ->
    if element
      htmlBlock =
        '<a class = "preview__small popup-block-link" href="'+element.DETAIL_PAGE_URL+'">
          <h4 class="preview-small__title">'+element.NAME+'</h4>
          <div class="preview-small__date">'+element.ACTIVE_FROM+'</div>
        </a>'
      return htmlBlock

  # метод генерации блока новости скартинкой
  getBlockWithGallery: (element) ->
    if element
      photoIcon =
        '<svg width="58" height="58" viewBox="0 0 58 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Canvas" transform="translate(-41032 -556)">
            <g id="Group">
              <g id="Oval 5">
                <use xlink:href="#path0_stroke" transform="translate(41033 557)" fill="#CCCCD3"/>
              </g>
              <g id="photo-camera">
                <g id="Shape">
                <use xlink:href="#path1_fill" transform="translate(41049 576)" fill="#FFFFFF"/>
                </g>
              </g>
            </g>
          </g>
          <defs>
          <path id="path0_stroke" d="M 28 56.5C 43.7401 56.5 56.5 43.7401 56.5 28L 55.5 28C 55.5 43.1878 43.1878 55.5 28 55.5L 28 56.5ZM 56.5 28C 56.5 12.2599 43.7401 -0.5 28 -0.5L 28 0.5C 43.1878 0.5 55.5 12.8122 55.5 28L 56.5 28ZM 28 -0.5C 12.2599 -0.5 -0.5 12.2599 -0.5 28L 0.5 28C 0.5 12.8122 12.8122 0.5 28 0.5L 28 -0.5ZM -0.5 28C -0.5 43.7401 12.2599 56.5 28 56.5L 28 55.5C 12.8122 55.5 0.5 43.1878 0.5 28L -0.5 28Z"/>
          <path id="path1_fill" fill-rule="evenodd" d="M 18.7188 3.5625L 21.6016 3.5625C 22.9219 3.5625 24 4.63123 24 5.9375L 24 16.625C 24 17.9313 22.9219 19 21.6016 19L 2.39844 19C 1.07812 19 0 17.9313 0 16.625L 0 5.9375C 0 4.63123 1.07812 3.5625 2.39844 3.5625L 5.28125 3.5625C 5.67578 3.5625 6.10156 3.25848 6.22656 2.88684L 6.97266 0.675903C 7.09766 0.304016 7.52344 0 7.92188 0L 16.0781 0C 16.4766 0 16.9023 0.304016 17.0273 0.675659L 17.7734 2.8866C 17.8984 3.25848 18.3242 3.5625 18.7188 3.5625ZM 8.39844 10.6875C 8.39844 8.72052 10.0117 7.125 12 7.125C 13.9883 7.125 15.5977 8.72052 15.5977 10.6875C 15.5977 12.6552 13.9883 14.25 12 14.25C 10.0117 14.25 8.39844 12.6552 8.39844 10.6875ZM 12 16.625C 8.6875 16.625 6 13.9667 6 10.6875C 6 7.40857 8.6875 4.75 12 4.75C 15.3125 4.75 18 7.40857 18 10.6875C 18 13.9667 15.3125 16.625 12 16.625ZM 19.9219 6.76709C 19.9219 7.22644 20.2969 7.59833 20.7617 7.59833C 21.2266 7.59833 21.6016 7.22644 21.6016 6.76709C 21.6016 6.30823 21.2266 5.93585 20.7617 5.93585C 20.2969 5.93585 19.9219 6.30823 19.9219 6.76709Z"/>
          </defs>
        </svg>'
      background = "background: url('"+element.DISPLAY_PREVIEW_PICTURE+"') no-repeat center; background-size: cover;"
      htmlBlock =
        '<a class="grid__column news popup-block-link" href="'+element.DETAIL_PAGE_URL+'">
              <div class="news-item__wrapper-block">
                <div class="news-item__preview-image" style="'+background+'">
                  <div class="preview__image"></div>
                  <div class="preview__image-mask preview__image-mask--for-gallery"></div>
                  <div class="news-photo-icon-wrapper">
                    <div class="news-photo-icon">'+photoIcon+'</div>
                    <p class="news-photo-icon__text">'+element.PROPERTY_GALLERY_IMAGES.length+' фотографий</p>
                  </div>
                </div>
                <div class="news-item__preview-title">'+element.NAME+'</div>
              </div>
              <div class="news-item__wrapper-block">
                <div class="news-item__preview-date preview-small__date">'+element.ACTIVE_FROM+'</div>
              </div>
            </a>'
      return htmlBlock


  getBlockWithVideo: (element) ->
    if element
      background = "background: url('"+element.DISPLAY_PREVIEW_PICTURE+"') no-repeat center; background-size: cover;"
      playIconBlock = '
        <div class="video-news-icon-wrapper">
        <div class="base-icon-block-content preview-big__image-icon">\n' +
        '            <div class="base-icon-block">\n' +
        '              <svg width="30" height="38" viewBox="0 0 30 38" version="1.1"\\n\' +\n' +
        '        \'     xmlns="http://www.w3.org/2000/svg"\\n\' +\n' +
        '        \'     xmlns:xlink="http://www.w3.org/1999/xlink">\\n\' +\n' +
        '        \'\\n\' +\n' +
        '        \'    <g transform="translate(-5398 -3510)">\\n\' +\n' +
        '        \'        <g>\\n\' +\n' +
        '        \'            <use xlink:href="#play_icon_svg"\\n\' +\n' +
        '        \'                 transform="matrix(6.12323e-17 1 -1 6.12323e-17 5428 3510)"/>\\n\' +\n' +
        '        \'        </g>\\n\' +\n' +
        '        \'    </g>\\n\' +\n' +
        '        \'    <defs>\\n\' +\n' +
        '        \'        <path id="play_icon_svg" fill-rule="evenodd" d="M 19 0L 38 30L 0 30L 19 0Z"/>\\n\' +\n' +
        '        \'    </defs>\\n\' +\n' +
        '        \'</svg>\n' +
        '                    </div>\n' +
        '                  </div>\n' +
        '               </div>'
      htmlBlock =
        '<a class="grid__column news popup-block-link" href="'+element.DETAIL_PAGE_URL+'">
                  <div class="news-item__wrapper-block">
                    <div class="news-item__preview-image" style="'+background+'">
                      <div class="preview__image"></div>
                      <div class="preview__image-mask"></div>'+playIconBlock+'
                    </div>
                    <div class="news-item__preview-title">'+element.NAME+'</div>
                  </div>
                  <div class="news-item__wrapper-block">
                    <div class="news-item__preview-date preview-small__date">'+element.ACTIVE_FROM+'</div>
                  </div>
                </a>'

      return htmlBlock

# метод генерации блока новости галлереи
  getBlockWithPicture: (element) ->
    if element
      background = "background: url('"+element.DISPLAY_PREVIEW_PICTURE+"') no-repeat center; background-size: cover;"
      htmlBlock =
        '<a class="grid__column news popup-block-link" href="'+element.DETAIL_PAGE_URL+'">
              <div class="news-item__wrapper-block">
                <div class="news-item__preview-image" style="'+background+'">
                  <div class="preview__image"></div>
                  <div class="preview__image-mask"></div>
                </div>
                <div class="news-item__preview-title">'+element.NAME+'</div>
              </div>
              <div class="news-item__wrapper-block">
                <div class="news-item__preview-date preview-small__date">'+element.ACTIVE_FROM+'</div>
              </div>
            </a>'
      return htmlBlock

  # метод генерации блока новости без картинки
  getBlockWithoutPicture: (element) ->
    annonce_class = ''
    if element
#     Если в тексте есть слово анонс, то добавляем ему соответствующий класс для другого стиля
      if element.NAME
        if element.NAME.includes('Анонс')
          annonce_class = 'news--annonce'
      htmlBlock =
        '<a class="news news--without-image popup-block-link '+annonce_class+'" href="'+element.DETAIL_PAGE_URL+'">
            <div class="news-item__preview-date preview-small__date">'+element.ACTIVE_FROM+'</div>
            <div class="news-item__wrapper-block">
              <div class="news-item__preview-title">'+element.NAME+'</div>
            </div>
          </a>'

      return htmlBlock

  getPaginationBlock: ->
#    @pageNumber++
    htmlBlock =
      '<div class="grid-3column news__action-bottom-block">
        <div></div>
        <div class="grid__column">
          <button class="base-button-transparent--middle js-pagination">Показать предыдущие новости</button>
        </div>
        <div></div>
      </div>'

    return htmlBlock

  clearContent: ->
    $('.js-loaded-items-main-container').html('');
    $('.js-loaded-items-container').html('');
    $('.news__action-bottom-block').remove();


// WEBPACK FOOTER //
// ./assets/javascripts/app/ajax_load_news_content.coffee